module.exports = __webpack_public_path__ + "img/benjamin-franklin-palmer.1cf62c38.png";